import * as React from "react";
import moment from "moment";

const passthroughProps = ['required', 'name', 'placeholder', 'min', 'max', 'step'];

function DateInput(props) {
    const {
        label,
        required = false,
        disabled = false,
        withSeconds = false,     // pokud chceš sekundovou přesnost, nastav true
        step = withSeconds ? 1 : 60, // krok v sekundách pro datetime-local
        onChange,
        ...rest
    } = props;

    const fmt = withSeconds ? 'YYYY-MM-DD[T]HH:mm:ss' : 'YYYY-MM-DD[T]HH:mm';

    const formatForInput = (val) => {
        if (val === undefined || val === null || val === '') return '';
        const m = moment(val);
        return m.isValid() ? m.format(fmt) : '';
    };

    const buildProps = () => {
        const result = {};
        // prop 'value' zpracujeme samostatně, aby byla vždy správně formátovaná
        if ('value' in rest) {
            result.value = formatForInput(rest.value);
        }

        // min/max/placeholder/required/name/step propustíme (min/max naformátujeme)
        passthroughProps.forEach((p) => {
            if (p in rest) {
                if (p === 'min' || p === 'max') {
                    result[p] = formatForInput(rest[p]);
                } else if (p === 'step') {
                    result[p] = rest[p];
                } else {
                    result[p] = rest[p];
                }
            }
        });

        // nastav defaultní step pokud nebyl předán
        if (!('step' in result)) {
            result.step = step;
        }

        return result;
    };

    const handleChange = (e) => {
        // e.target.value je ve formátu 'YYYY-MM-DDTHH:mm' (případně se sekundami)
        // ponecháme jako string – je to nejméně překvapivé pro zpracování v parentu
        onChange && onChange(e.target.value);
    };

    const inputProps = buildProps();

    return (
        <label className="FormInput col-50">
            <label className={`${required ? 'required' : ''}`}>{label}</label>
            <input
                type="datetime-local"
                {...inputProps}
                disabled={disabled}
                onChange={handleChange}
                className={`appearance-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500
          text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm
          rounded-t-md`}
                autoComplete="off"
            />
        </label>
    );
}

export default DateInput;
